module.exports = __webpack_public_path__ + "static/media/ski.41cca8d9.svg";